<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.VerificationOfEstimatedProfitMargin')"
    width="500px"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :inline="true" label-width="150px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="`${$t('Message.EstimatedIncome')}(${$t('Message.EquivalentToRMB')})`">
            <el-input-number
              v-model="job.estimateAccountsReceivable"
              :disabled="!editable"
              :min="-999999999999"
              :max="999999999999"
              :precision="2"
              :controls="false"
              @change="calcuProfit"
            />
          </el-form-item>
          <el-form-item :label="`${$t('Message.EstimatedCost')}(${$t('Message.EquivalentToRMB')})`">
            <el-input-number
              v-model="job.estimateAccountsPayable"
              :disabled="!editable"
              :min="-999999999999"
              :max="999999999999"
              :precision="2"
              :controls="false"
              @change="calcuProfit"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.EstimatedProfit')">
            <label>{{ formatNumberToThousands(job.estimateGrossProfit.toFixed(2), 2) }}</label>
          </el-form-item>
          <br>
          <el-form-item :label="$t('Message.EstimatedProfitMargin')">
            <label>{{ grossProfitTxt }}</label>
          </el-form-item>
          <el-form-item :label="$t('Message.EstimatedRemarks')">
            <el-input v-model="job.situation" type="textarea" :rows="3" />
          </el-form-item>
        </div>
        <span v-show="!editable">{{ $t('queryJob.EstimatedProfitNotCompanyRegulations').replace('{0}', `(0 ~ ${estimateProfitRate}%)`) }}</span>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="confirm">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="cancel" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'
import { formatNumberToThousands } from '@/utils'

export default {
  name: 'EstimateValidationDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    editable: { type: Boolean, default: false },
    estimateProfitRate: { type: Number, default: 0 },
    tatolProfit: { type: Number, default: 0 }
  },
  data() {
    return {
      formatNumberToThousands,
      innerVisible: this.visible,
      grossProfitTxt: ''
    }
  },
  computed: { },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.exgrossProfit()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    editable: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.calcuProfit()
        }
      }
    }
  },
  methods: {
    calcuProfit() {
      const job = this.job
      job.estimateGrossProfit = job.estimateAccountsReceivable - job.estimateAccountsPayable
      if (job.estimateAccountsReceivable === 0) {
        this.grossProfitTxt = '0.0%'
      } else {
        this.grossProfitTxt = job.estimateGrossProfit === 0 ? '0.0%' : NumberUtils.formatNumber((job.estimateAccountsReceivable - job.estimateAccountsPayable) / job.estimateAccountsReceivable * 100, 2) + '%'
      }
    },
    exgrossProfit() {
      if (this.job.estimateGrossProfit === 0) {
        this.grossProfitTxt = '0.0%'
      } else {
        this.grossProfitTxt = this.tatolProfit.toFixed(2) + '%'
      }
    },
    confirm() {
      if (!this.editable && !this.job.situation.trim()) {
        this.$message.info(this.$t('Message.EstimatedMustBeFilledIn'))
        return
      }
      this.$emit('callback', true)
      this.innerVisible = false
    },
    cancel() {
      this.job.situation = ''
      this.$emit('callback', false)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
